export const termsData = {
  title: "Terms and Conditions",
  sections: [
    {
      title: "1. Introduction and Definitions",
      content: [
        "Maruti Suzuki India Limited (MSIL) has onboarded service workshops as its authorized workshops termed as Maruti Suzuki Authorized Service Stations (MASS). The onboarding of MASS is subject to and in accordance with the Maruti Authorised Service Station Agreement entered between MSIL and the respective MASS's (MASS Agreement). MSIL offers voice call and chat bot services (Service(s)/Digital Service(es)) subscription plans for MASS through Maruti Suzuki Digital Business Hub portal (Mass Business Zone Portal) on prepaid basis."
      ]
    },
    {
      title: "2. Purpose and Acceptance of Services",
      content: [
        "MASS understands and agrees that objective of these Services is to digitally support MASS workshop's day to day business operations."
      ]
    },
    {
      title: "3. Payments",
      content: [
        "Since the Services are available on prepaid subscription model, MASS, at the time of opting for a Service package, shall pay the subscription fee for the same (Subscription Fee) through the Mass Business Zone Portal. By opting to subscribe for the Services, MASS hereby agrees to provide MSIL the right to debit the Subscription Fee on prepaid basis from the financial account provided by MASS and as available in MSIL records. The Subscription Fee reflected and chargeable on the Mass Business Zone Portal shall be inclusive of all applicable taxes."
      ]
    },
    {
      title: "4. Service Operation, Termination and Refund",
      content: [
        "The Services shall be rendered by MSIL through its identified vendor/business partner on a principal-to-principal basis, and the MASS acknowledges and agrees that MSIL is not liable and/or responsible for the quality and/or continuity of the Services and MASS shall have no claim against MSIL for the same. MASS shall allow MSIL to permit MSIL's business partners/vendors to operate the Services on behalf of MASS, as per subscription plan opted by MASS. MASS accepts that Services once subscribed cannot be paused/halted/terminated by MASS until the completion of subscription or termination of the MASS Agreement, whichever is earlier. However, MSIL reserves the right to terminate the Services at any time without requiring intimating MASS beforehand. Furthermore, in case of termination of the Services by virtue of termination of MASS Agreement or otherwise, no refund of unutilized prepaid Subscription Fee can be claimed by the MASS."
      ]
    },
    {
      title: "5. Service Rules, Schedule, and Modifications",
      content: [
        "MASS accepts that the Services will run as per rules, schedule and process framed and circulated by MSIL from time to time, at the sole discretion of MSIL. Furthermore, by virtue of being on the Mass Business Zone Portal, MASS agrees to accept any changes/modification in the rules, schedule, and process of the Service offerings at any time with or without any intimation by MSIL."
      ]
    },
    {
      title: "6. Service Renewal",
      content: [
        "In the event the MASS has opted for auto debit function for renewal of selected Service package after the end of the subscription term; the Services shall get automatically renewed with applicable auto debit fees till MASS manually disables the auto debit function in the Mass Business Zone Portal."
      ]
    },
    {
      title: "7. Scope of Voice and Chat Bot Services",
      content: [
        "Voice + Chat bot shall call all the customers for whom SMR / Service is due or for whom a valid mobile number is available in Dealer Management System software (DMS) while the selected Service package is active."
      ]
    },
    {
      title: "8. Lead and Feedback Sharing",
      content: [
        "The leads/feedback generated shall be shared with MASS over DMS or any other portals shared by MSIL and not on the Mass Business Zone Portal."
      ]
    },
    {
      title: "9. Customer Contact Authorization",
      content: [
        "For the purpose of Services, MASS records the diagnosis, service and repair details in the DMS. In order to facilitate the customers by way of service reminders, promotional campaigns etc., the DMS details shall be used in contacting the customers."
      ]
    },
    {
      title: "10. Performance Disclaimer",
      content: [
        "MASS understands and accepts that performance of Chat/Voice bots and leads/feedback generated are basis responses of customers in the database. Since the performance is dependent on the quality of database being maintained, MSIL claims no guarantee of performance of digital offerings in relation to the Services at any point in time. MASS acknowledges that any incidents or damages resulting from digital system failures shall be the sole responsibility of MASS."
      ]
    },
    {
      title: "11. Campaign Offer Updates",
      content: [
        "Any customer campaign or offers promulgated by MSIL may get flashed in the Mass Business Zone Portal for ease of reference by the MASS. MASS can use such details on their dedicated campaigns."
      ]
    },
    {
      title: "12. MASS Responsibility for Leads and Feedback",
      content: [
        "MASS understands and agrees that leads/feedback generated by the Voice + Chat Bot shall in-turn assist it to boost its service business load, revenue and customer satisfaction. However, MASS shall remain responsible for the responses received, follow-up and conversion of leads/resolution of feedback and resolving concerns of the customers."
      ]
    },
    {
      title: "13. MSIL's Right to Modify Campaign Details",
      content: [
        "MSIL reserves the right to determine the nature, source, structure, and use of such data solely for the purpose of providing Services to MASS. MSIL reserves the right to change the terms and conditions, details and duration of the campaigns/ offers at its sole discretion with or without prior intimation to MASS."
      ]
    },
    {
      title: "14. Compliance with Laws and Regulations",
      content: [
        "The compliance of TRAI and Telecom Regulations and all other applicable laws and rules are to be abided to by MASS who are availing the services. Any query/dispute from the regulatory authorities and/or customers shall be resolved by MASS."
      ]
    },
    {
      title: "15. Queries and Support Contact",
      content: [
        "MSIL reserves the right to deploy one or more vendors for the Services and also has the right to change or replace vendors from time to time at its discretion. In order to maintain a single point of contact, all queries or clarifications from MASS in relation to services shall be routed through the respective MSIL regional offices/service teams."
      ]
    },
    {
      title: "16. General Applicability and Contact Information",
      content: [
        "These offers will be applicable for both chat and voice bot Services. For any query, please contact your MSIL Regional Office."
      ]
    },
    {
      title: "17. Do Not Disturb (DND) Registration",
      content: [
        "If any contact number of customer is registered under DND, such customers shall not be contacted through the Services of Mass Business Zone Portal. Additionally, in order to mark any phone number in Do Not Disturb category for stopping Service marketing calls/chats, email request for the same containing the customer details and phone number may be sent to cs@rezo.ai & support@rezo.ai."
      ]
    },
    {
      title: "18. General Legal Provisions",
      content: [
        "MASS is responsible for adhering to all applicable data privacy and security regulations and for maintaining the privacy, security, confidentiality, and integrity of all information accessible from digital sources at its end. MASS indemnifies MSIL for any disputes arising from the Services. In the event of any conflict between these terms and conditions and the MASS Agreement, the MASS Agreement shall prevail. The terms and conditions contained herein is addition to the those contained in the MSIL Agreement is subject to change by MSIL, at its sole discretion, at any time without prior intimation to MASS. The updated terms and condition shall be available in the Mass Business Zone Portal."
      ]
    },
    {
      title: "19. Jurisdiction, Governing Law and Dispute Resolution",
      content: [
        "The governing law, dispute resolution mechanism and jurisdiction of courts for adjudication of disputes in relation to these Terms and Conditions shall be as per MASS Agreement."
      ]
    }
  ]
};

